import { Button, PoweredBy, ProgressStepper } from "@justhome/react-ui";
import clsx from "clsx";
import { FC, PropsWithChildren } from "react";
import { useTranslation } from "../../lib/hooks/useTranslations";
import Fade from "../Fade";

interface EmbedLayoutBodyProps extends PropsWithChildren {
  state: any;
  currentStepNumber: number;
  numberOfSteps: number;
  showProgress?: boolean;
}

const EmbedLayoutBody: FC<EmbedLayoutBodyProps> = ({
  children,
  state = 1,
  currentStepNumber,
  numberOfSteps,
  showProgress = true,
}) => {
  return (
    <>
      {showProgress && typeof numberOfSteps === "number" && (
        <div className="w-full flex flex-col gap-2xs mb-3s m:mb-3m">
          <ProgressStepper
            currentStep={currentStepNumber}
            steps={numberOfSteps}
          />
          <PoweredBy />
        </div>
      )}

      <div className={clsx("flex flex-col items-center")}>
        <Fade state={state}>{children}</Fade>
      </div>
    </>
  );
};

const EmbedLayoutAside = ({ children }: any) => {
  return <div className="hidden m:flex w-[440px]">{children}</div>;
};

const EmbedLayoutMobileFooter: FC<
  PropsWithChildren<{ onPrevious: () => void }>
> = ({ children, onPrevious }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-none left-none right-none m:hidden py-2xs px-s flex justify-between bg-neutral-0 border-t border-neutral-25">
      <Button
        onClick={onPrevious}
        variant="ghost"
        size="md"
        iconStart="Left"
        paddingX
      >
        {t("link_back_previous")}
      </Button>
      {children}
    </div>
  );
};

const EmbedLayout: FC<PropsWithChildren> = ({ children }: any) => {
  return (
    <div className="flex flex-col items-center min-h-[630px]">{children}</div>
  );
};

export default Object.assign(EmbedLayout, {
  Aside: EmbedLayoutAside,
  Body: EmbedLayoutBody,
  MobileFooter: EmbedLayoutMobileFooter,
});
